import { render, staticRenderFns } from "./FileQueryResults.vue?vue&type=template&id=5bdf0da0&"
import script from "./FileQueryResults.vue?vue&type=script&lang=ts&"
export * from "./FileQueryResults.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports